export const selectList = [
  'title',
  'title_th',
  'gender',
  'marital_status',
  'is_active',
  'line_manager_id',
  'employee_type',
  'position_id',
  'company_id',
  'lob_id',
  'department_id',
  'division_id',
  'team_id',
  'level',
  'emp_bonus_mth',
  'money_adjust_month',
  'referral',
]

export const _title = [
  { label: 'Mr.', value: 'Mr.' },
  { label: 'Mrs.', value: 'Mrs.' },
  { label: 'Ms.', value: 'Ms.' },
]

export const _title_th = [
  { label: 'นาย', value: 'นาย' },
  { label: 'นางสาว', value: 'นางสาว' },
  { label: 'นาง', value: 'นาง' },
  { label: 'ว่าที่ร.ต.', value: 'ว่าที่ร.ต.' },
  { label: 'ว่าที่ร.ต.หญิง', value: 'ว่าที่ร.ต.หญิง' },
]

export const _marital_status = [
  { label: 'Single', value: 'single' },
  { label: 'Married', value: 'married' },
  { label: 'Divorced', value: 'divorced' },
]

export const _gender = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
]

export const _status = [
  { label: 'Active', value: true },
  { label: 'Inactive', value: false },
]

export const _employee_type = [
  { label: 'Full-Time', value: 'Full-Time' },
  { label: 'Subcontract', value: 'Subcontract' },
  { label: 'Trainee', value: 'Trainee' },
  { label: 'Part-Time', value: 'Part-Time' },
]

export const _levels = [
  { label: 'Junior', value: 'Junior' },
  { label: 'Consultant', value: 'Consultant' },
  { label: 'Senior Consultant', value: 'Senior Consultant' },
  { label: 'Manager', value: 'Manager' },
  { label: 'Asst. VP', value: 'Asst. VP' },
  { label: 'VP', value: 'VP' },
  { label: 'Director', value: 'Director' },
  { label: 'BOS', value: 'BOS' },
]

export const months = [
  { label: 'January', value: '1' },
  { label: 'February', value: '2' },
  { label: 'March', value: '3' },
  { label: 'April', value: '4' },
  { label: 'May', value: '5' },
  { label: 'June', value: '6' },
  { label: 'July', value: '7' },
  { label: 'August', value: '8' },
  { label: 'September', value: '9' },
  { label: 'October', value: '10' },
  { label: 'November', value: '11' },
  { label: 'December', value: '12' },
]



// WEBPACK FOOTER //
// ./src/components/new-employee/types.js